import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useArchiveGiftCardGroupMutation = createMutationHook(
  GiftCardsApiClient.archiveGiftCardGroup,
  {
    mutationKey: ['archiveGiftCardGroup'],
  },
)
